export enum Seguradoras {
  ALIRO = "Aliro",
  YELUM = "Yelum",
}
